import { render, staticRenderFns } from "./DisplayAdmin.vue?vue&type=template&id=69782f60&scoped=true&"
import script from "./DisplayAdmin.vue?vue&type=script&lang=js&"
export * from "./DisplayAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DisplayAdmin.vue?vue&type=style&index=0&id=69782f60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69782f60",
  null
  
)

export default component.exports